define('app/views/guest_checkout_user_info_view',['app/setup'], function(takhfifan) {

  takhfifan.guestCheckoutUserInfoView = Backbone.View.extend({

    events: {
      'submit .inline-form': 'submitGuestCustomerInfo'
    },

    initialize: function(options) {
      Backbone.Validation.bind(this);
      var _this = this;
      this.$submitBtn = $("#tkhGuestCustomerInfoSubmitBtn");
      this._buttonContents = this.$submitBtn.html();
      takhfifan.eventHub.on('guest_customer_info:saved', function(data) {
        if(data.type == 'simple') {
          takhfifan.eventHub.trigger('checkout:shipping', []);
          //takhfifan.eventHub.trigger('shipping:method_updated',data);
        }
        if(data.type == 'virtual') {
          takhfifan.eventHub.trigger('checkout:payment', []);
        }
      });

      takhfifan.eventHub.on('guest_customer_info:error', function(errors) {
        _this.enableForm();
        var message = errors[0];
        if(_.isNull(message) || _.isEmpty(message)){
          message = i18n.t('connection_error');
        }
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: message
        });
      });
      this.$el.find('.inline-form input[required]').on('change invalid', function() {
        var textfield = $(this).get(0);

        textfield.setCustomValidity('');

        if (!textfield.validity.valid) {
          var $name = $(this).attr('name');
          if ($name === 'email') {
            textfield.setCustomValidity('لطفا آدرس ایمیل خود را وارد کنید');
          }else{
            textfield.setCustomValidity('برای ادامه می باید شرایط و قوانین را بپذیرید');
          }
        }
      });
    },

    submitGuestCustomerInfo: function(evt){
      this.$el.find('.inline-form input[required]').each(function () {
        if(!$(this)[0].checkValidity()){
          return;
        }
      });
      evt.preventDefault();
      var _this=this;
      var payload = {};
      this.$(":input").each(function(index){
        if(!_.isUndefined($(this).attr('name'))) {
          payload[$(this).attr('name')] = $(this).val();
          if($(this).attr('name') == 'region') {
            payload['region_id'] = $(this).val();
          }
        }
      });
      this.model.set(payload, { validate: true });
      if(this.model.isValid()) {
        this.disableForm();
        this.model.save(this.$el.data('url'));

        takhfifan.eventHub.trigger('ga:checkoutOption', {
          "step": 2,
          "option": "guest"
        });
      }

    },

    disableForm: function() {
      this.$submitBtn.prop('disabled',true);
      this.$submitBtn.empty().append('<div class="btn-text"><span class="spinner"></span></div>');
    },

    enableForm: function() {
      this.$submitBtn.prop('disabled',false);
      this.$submitBtn.empty().append(this._buttonContents);
    },



  });
});

